import { Injectable } from '@angular/core';

import { isString } from 'lodash-es';
import { StakeErrorType, StakeValidationResult } from 'packages/sports/web/app/src/betslip-base/stake-validation/stake-validation.models';
import { NumpadDisplayService } from 'packages/sports/web/app/src/numpad/numpad-display.service';
import { Observable, map, of } from 'rxjs';

import { BetslipError } from '../../../validation/errors/betslip-error';
import { BetslipErrorMessageFormatterService } from '../../../validation/services/formatting/betslip-error-message-formatter.service';
import { validateStake } from '../../utils';

@Injectable()
export class BetslipStakeValidationService {
    constructor(
        private numpadDisplayService: NumpadDisplayService,
        private formatterService: BetslipErrorMessageFormatterService,
    ) {}

    validateStake(stakeError: BetslipError | undefined, actualStake: string | null): BetslipError | null {
        return validateStake(stakeError, actualStake, this.numpadDisplayService.isOpen());
    }

    formatStakeError(error: BetslipError | null): Observable<StakeValidationResult | null> {
        if (!error) {
            return of(null);
        }

        return this.formatterService.getErrorMessage(error).pipe(
            map((message) => {
                if (!message) {
                    return null;
                }

                if (isString(message)) {
                    return {
                        message,
                        type: StakeErrorType.LessThanMin,
                    };
                }

                return {
                    message: message.message,
                    type: StakeErrorType.LessThanMin,
                    callback: message.callback,
                };
            }),
        );
    }
}
